import { SWRConfig } from 'swr';
import {
  fetchScheduleCard,
  fetchTestSeriesDetails,
  getScheduleInfoKey
} from '@api/fetchers/test-series';
import Layout from '@layout/index';
import { emptyObject } from '@constants/empty';
import Header from '@cont/Store/TestSeries/FullSchedule/Header';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import CardsContainer from '@cont/Store/TestSeries/FullSchedule/CardsContainer';
import { processScheduleCardInfo } from '@cont/Store/TestSeries/FullSchedule/utils';
import { getTestSeriesDetailsAPIKey } from '@cont/SeeAll/utils';
import useTestSeriesInfo from '@cont/SeeAll/TestSeriesListing/TestSeriesRevamp/useTestSeriesInfo';

const Schedule = ({ courseUID, fallback }) => {
  const scheduleCardKey = getScheduleInfoKey(courseUID);
  const testSeriesInfokey = getTestSeriesDetailsAPIKey(courseUID);
  const testData = fallback.testSeriesData;
  const { data: testSeriesData } = useTestSeriesInfo({
    testData,
    revalidateOnMount: true
  });
  return (
    <SWRConfig
      value={{
        fallback: {
          [scheduleCardKey]: fallback.cardsByDate,
          [testSeriesInfokey]: testSeriesData
        }
      }}
    >
      <Header />
      <CardsContainer />
    </SWRConfig>
  );
};

Schedule.pageInfo = {
  name: 'Full Schedule',
  isMWebSupported: true,

  layoutOptions: {
    hideFooter: true,
    noMobilePadding: true,
    useLightBaseColor: true
  }
};

export const getStaticProps = async ({ params }) => {
  const { courseUID } = params ?? emptyObject;

  try {
    const resp = await fetchScheduleCard(courseUID);
    const processedScheduleInfo = processScheduleCardInfo(resp);
    const testSeriesData = await fetchTestSeriesDetails(courseUID);

    return {
      props: {
        fallback: {
          cardsByDate: processedScheduleInfo,
          testSeriesData
        },
        courseUID
      },
      revalidate: 5
    };
  } catch {
    return { notFound: true, revalidate: 2 * 60 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default Schedule;

Schedule.Layout = Layout;
Schedule.Wrapper = PageReduxProvider;
